import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class HotBg extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop()
    disabled: boolean;

  render(h) {
    return (
      // 暂时图片不截取 + "?imageView2/1/w/750/h/400"
      <div class="user-info">
        <img src={this.value.desc.showBackPic === 1 && this.value.desc.backPic} style={{ width: '100%' }} />
      </div>
    );
  }
}
